import React from 'react'

const Sresult = () => {
	const pageStyle ={
		backgroundImage: 'url("https://www.matrimonysoftware.in/images/background/5.jpg")'
	}
  return (
    <>
	<section class="page-title" style={pageStyle} >
        <div class="auto-container">
            <h1 class="d-none d-lg-block d-xl-block d-md-block"> Search Result</h1>
            <ul class="bread-crumb clearfix">
                <li><a href="index">Home</a></li>
                <li>  Search Result</li>
            </ul>
        </div>
    </section>
    <section class="speakers-section-three">
        <div class="auto-container">
            
             
            <div class="row">
			    
                    
				
                <div class="speaker-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" >
				     
                    <div class="inner-box">
                     <div class="image-box">
					 
                            <figure class="image"><a href="login" target="_blank">							
															<img src="https://www.matrimonysoftware.in/photoprocess.php?image=gallary/2021_07_10_06_51_04how-to-wear-traditional-indian-sarees-2.jpg&square=200"/>
 
										   							</a></figure> 
                      </div>
					  
                      <div class="info-box">
						<h4 class="name"><a href="login" target="_blank">	
						ND91837</a></h4><a href="login" target="_blank">
						<span class="designation">Unmarried</span>
						<span class="designation">Hindu</span>
						<span class="designation">23 Yrs</span>
                      </a></div><a href="login" target="_blank">
					  </a>
                      <div class="social-box">                            
					  <ul class="social-links social-icon-colored">
							 <div class="wrapper">
			 <li><a href="login" target="_blank"><i class="fas fa-user fa-skype"></i></a></li>
             <div class="tooltip"> Profile </div>
				</div>
			<div class="wrapper">
		     <li><a href="login" target="_blank"><i class="fas fa-heart fa-google-plus"></i></a></li>
             <div class="tooltip"> Shortlist</div>
			</div>
			<div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-comment-dots fa-bitbucket"></i></a></li>
             <div class="tooltip"> Message</div>
			</div>
			 <div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-user-plus fa-bitcoin"></i></a></li>
             <div class="tooltip"> Connect</div>
			</div>
						</ul>
                     </div>
                  </div>
               </div>
			    
				
                <div class="speaker-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated">
				     
                    <div class="inner-box">
                     <div class="image-box">
					 
                            <figure class="image"><a href="login" target="_blank">							
																   
							<img src="https://www.matrimonysoftware.in/photoprocess.php?image=gallary/2021_07_10_06_51_04how-to-wear-traditional-indian-sarees-2.jpg&square=200"/>

										 
										 							</a></figure> 
                      </div>
					  
                      <div class="info-box">
						<h4 class="name"><a href="login" target="_blank">	
						ND12242</a></h4><a href="login" target="_blank">
						<span class="designation">Unmarried</span>
						<span class="designation">Hindu</span>
						<span class="designation">22 Yrs</span>
                      </a></div><a href="login" target="_blank">
					  </a>
                      <div class="social-box">                            
					  <ul class="social-links social-icon-colored">
							 <div class="wrapper">
			 <li><a href="login" target="_blank"><i class="fas fa-user fa-skype"></i></a></li>
             <div class="tooltip"> Profile </div>
				</div>
			<div class="wrapper">
		     <li><a href="login" target="_blank"><i class="fas fa-heart fa-google-plus"></i></a></li>
             <div class="tooltip"> Shortlist</div>
			</div>
			<div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-comment-dots fa-bitbucket"></i></a></li>
             <div class="tooltip"> Message</div>
			</div>
			 <div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-user-plus fa-bitcoin"></i></a></li>
             <div class="tooltip"> Connect</div>
			</div>
						</ul>
                     </div>
                  </div>
               </div>
			    
				
             
                <div class="speaker-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" >
				     
                    <div class="inner-box">
                     <div class="image-box">
					 
                            <figure class="image"><a href="login" target="_blank">							
																	
							<img src="https://www.matrimonysoftware.in/photoprocess.php?image=gallary/2021_07_10_06_51_04how-to-wear-traditional-indian-sarees-2.jpg&square=200"/>
											 							</a></figure> 
                      </div>
					  
                      <div class="info-box">
						<h4 class="name"><a href="login" target="_blank">	
						ND78347</a></h4><a href="login" target="_blank">
						<span class="designation">Unmarried</span>
						<span class="designation">Hindu</span>
						<span class="designation">23 Yrs</span>
                      </a></div><a href="login" target="_blank">
					  </a>
                      <div class="social-box">                            
					  <ul class="social-links social-icon-colored">
							 <div class="wrapper">
			 <li><a href="login" target="_blank"><i class="fas fa-user fa-skype"></i></a></li>
             <div class="tooltip"> Profile </div>
				</div>
			<div class="wrapper">
		     <li><a href="login" target="_blank"><i class="fas fa-heart fa-google-plus"></i></a></li>
             <div class="tooltip"> Shortlist</div>
			</div>
			<div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-comment-dots fa-bitbucket"></i></a></li>
             <div class="tooltip"> Message</div>
			</div>
			 <div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-user-plus fa-bitcoin"></i></a></li>
             <div class="tooltip"> Connect</div>
			</div>
						</ul>
                     </div>
                  </div>
               </div>
			    
				
               
                <div class="speaker-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated">
				     
                    <div class="inner-box">
                     <div class="image-box">
					 
                            <figure class="image"><a href="login" target="_blank">							
																	
							<img src="https://www.matrimonysoftware.in/photoprocess.php?image=gallary/2021_07_10_06_51_04how-to-wear-traditional-indian-sarees-2.jpg&square=200"/>
											 							</a></figure> 
                      </div>
					  
                      <div class="info-box">
						<h4 class="name"><a href="login" target="_blank">	
						ND45709</a></h4><a href="login" target="_blank">
						<span class="designation">Unmarried</span>
						<span class="designation">Hindu</span>
						<span class="designation">23 Yrs</span>
                      </a></div><a href="login" target="_blank">
					  </a>
                      <div class="social-box">                            
					  <ul class="social-links social-icon-colored">
							 <div class="wrapper">
			 <li><a href="login" target="_blank"><i class="fas fa-user fa-skype"></i></a></li>
             <div class="tooltip"> Profile </div>
				</div>
			<div class="wrapper">
		     <li><a href="login" target="_blank"><i class="fas fa-heart fa-google-plus"></i></a></li>
             <div class="tooltip"> Shortlist</div>
			</div>
			<div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-comment-dots fa-bitbucket"></i></a></li>
             <div class="tooltip"> Message</div>
			</div>
			 <div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-user-plus fa-bitcoin"></i></a></li>
             <div class="tooltip"> Connect</div>
			</div>
						</ul>
                     </div>
                  </div>
               </div>
			    
				
                <div class="speaker-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" >
				     
                    <div class="inner-box">
                     <div class="image-box">
					 
                            <figure class="image"><a href="login" target="_blank">							
																	
							<img src="https://www.matrimonysoftware.in/photoprocess.php?image=gallary/2021_07_10_06_51_04how-to-wear-traditional-indian-sarees-2.jpg&square=200"/>
											 							</a></figure> 
                      </div>
					  
                      <div class="info-box">
						<h4 class="name"><a href="login" target="_blank">	
						ND91200</a></h4><a href="login" target="_blank">
						<span class="designation">Unmarried</span>
						<span class="designation">Hindu</span>
						<span class="designation">22 Yrs</span>
                      </a></div><a href="login" target="_blank">
					  </a>
                      <div class="social-box">                            
					  <ul class="social-links social-icon-colored">
							 <div class="wrapper">
			 <li><a href="login" target="_blank"><i class="fas fa-user fa-skype"></i></a></li>
             <div class="tooltip"> Profile </div>
				</div>
			<div class="wrapper">
		     <li><a href="login" target="_blank"><i class="fas fa-heart fa-google-plus"></i></a></li>
             <div class="tooltip"> Shortlist</div>
			</div>
			<div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-comment-dots fa-bitbucket"></i></a></li>
             <div class="tooltip"> Message</div>
			</div>
			 <div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-user-plus fa-bitcoin"></i></a></li>
             <div class="tooltip"> Connect</div>
			</div>
						</ul>
                     </div>
                  </div>
               </div>
			    
				
               
                <div class="speaker-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" >
				     
                    <div class="inner-box">
                     <div class="image-box">
					 
                            <figure class="image"><a href="login" target="_blank">							
															<img src="https://www.matrimonysoftware.in/photoprocess.php?image=gallary/2021_07_10_06_51_04how-to-wear-traditional-indian-sarees-2.jpg&square=200"/>
 
										   							</a></figure> 
                      </div>
					  
                      <div class="info-box">
						<h4 class="name"><a href="login" target="_blank">	
						ND37854</a></h4><a href="login" target="_blank">
						<span class="designation">Unmarried</span>
						<span class="designation">Hindu</span>
						<span class="designation">26 Yrs</span>
                      </a></div><a href="login" target="_blank">
					  </a>
                      <div class="social-box">                            
					  <ul class="social-links social-icon-colored">
							 <div class="wrapper">
			 <li><a href="login" target="_blank"><i class="fas fa-user fa-skype"></i></a></li>
             <div class="tooltip"> Profile </div>
				</div>
			<div class="wrapper">
		     <li><a href="login" target="_blank"><i class="fas fa-heart fa-google-plus"></i></a></li>
             <div class="tooltip"> Shortlist</div>
			</div>
			<div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-comment-dots fa-bitbucket"></i></a></li>
             <div class="tooltip"> Message</div>
			</div>
			 <div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-user-plus fa-bitcoin"></i></a></li>
             <div class="tooltip"> Connect</div>
			</div>
						</ul>
                     </div>
                  </div>
               </div>
			    
				
                
                <div class="speaker-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" >
				     
                    <div class="inner-box">
                     <div class="image-box">
					 
                            <figure class="image"><a href="login" target="_blank">							
															<img src="https://www.matrimonysoftware.in/photoprocess.php?image=gallary/2021_07_10_06_51_04how-to-wear-traditional-indian-sarees-2.jpg&square=200"/>
 
										   							</a></figure> 
                      </div>
					  
                      <div class="info-box">
						<h4 class="name"><a href="login" target="_blank">	
						ND14472</a></h4><a href="login" target="_blank">
						<span class="designation">Unmarried</span>
						<span class="designation">Hindu</span>
						<span class="designation">25 Yrs</span>
                      </a></div><a href="login" target="_blank">
					  </a>
                      <div class="social-box">                            
					  <ul class="social-links social-icon-colored">
							 <div class="wrapper">
			 <li><a href="login" target="_blank"><i class="fas fa-user fa-skype"></i></a></li>
             <div class="tooltip"> Profile </div>
				</div>
			<div class="wrapper">
		     <li><a href="login" target="_blank"><i class="fas fa-heart fa-google-plus"></i></a></li>
             <div class="tooltip"> Shortlist</div>
			</div>
			<div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-comment-dots fa-bitbucket"></i></a></li>
             <div class="tooltip"> Message</div>
			</div>
			 <div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-user-plus fa-bitcoin"></i></a></li>
             <div class="tooltip"> Connect</div>
			</div>
						</ul>
                     </div>
                  </div>
               </div>
			    
				
           
                <div class="speaker-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" >
				     
                    <div class="inner-box">
                     <div class="image-box">
					 
                            <figure class="image"><a href="login" target="_blank">							
																   
								   								 <img src="https://www.matrimonysoftware.in/photoprocess.php?image=gallary/2021_07_10_06_51_04how-to-wear-traditional-indian-sarees-2.jpg&square=200"/>

										 
										 							</a></figure> 
                      </div>
					  
                      <div class="info-box">
						<h4 class="name"><a href="login" target="_blank">	
						ND77768</a></h4><a href="login" target="_blank">
						<span class="designation">Unmarried</span>
						<span class="designation">Hindu</span>
						<span class="designation">22 Yrs</span>
                      </a></div><a href="login" target="_blank">
					  </a>
                      <div class="social-box">                            
					  <ul class="social-links social-icon-colored">
							 <div class="wrapper">
			 <li><a href="login" target="_blank"><i class="fas fa-user fa-skype"></i></a></li>
             <div class="tooltip"> Profile </div>
				</div>
			<div class="wrapper">
		     <li><a href="login" target="_blank"><i class="fas fa-heart fa-google-plus"></i></a></li>
             <div class="tooltip"> Shortlist</div>
			</div>
			<div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-comment-dots fa-bitbucket"></i></a></li>
             <div class="tooltip"> Message</div>
			</div>
			 <div class="wrapper">
			<li><a href="login" target="_blank"><i class="fas fa-user-plus fa-bitcoin"></i></a></li>
             <div class="tooltip"> Connect</div>
			</div>
						</ul>
                     </div>
                  </div>
               </div>
			             </div>
			<div align="center" class="col-lg-12">
							<ul class="styled-pagination" id="pagination">
		      <ul class="setPaginate"><li class="setPage">Page 1 of 5</li><li><a class="active">1</a></li><li><a href="?page=2&amp;txtSAge=22&amp;txtEAge=31&amp;religion=Any&amp;looking=&amp;gender=Female">2</a></li><li><a href="?page=3&amp;txtSAge=22&amp;txtEAge=31&amp;religion=Any&amp;looking=&amp;gender=Female">3</a></li><li><a href="?page=4&amp;txtSAge=22&amp;txtEAge=31&amp;religion=Any&amp;looking=&amp;gender=Female">4</a></li><li><a href="?page=5&amp;txtSAge=22&amp;txtEAge=31&amp;religion=Any&amp;looking=&amp;gender=Female">5</a></li><li><a href="?page=2&amp;txtSAge=22&amp;txtEAge=31&amp;religion=Any&amp;looking=&amp;gender=Female"> <b> &gt; </b></a></li></ul>
			  </ul>		   
				  </div>
			</div>
			</section>
    </>
  )
}

export default Sresult